module.exports = __webpack_public_path__ + "img/ground-river-evening.2099cacf.png";